import React, { useEffect, useState, useRef } from 'react'
import { Box, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import getRequest, { patchRequest, postRequest, postRequestLogo, putRequest } from '../../../assets/helper/ApiHandler';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch } from 'react-redux';
import { setCompanyLogo } from '../../../redux/appLogoSlice';

var companyObject = {
    id: '',
    name: '',
    country: '',
    addressLine1: '',
    addressLine2: '',
    state: '',
    city: '',
    zipcode: '',
}

var formTouchedObj = {
    name: false,
    country: false,
    addressLine1: false,
    addressLine2: false,
    city: false,
    state: false,
    zipcode: false,
}

export default function Company() {
    const toast = useRef(null);
    const [companies, setCompanies] = useState(companyObject);
    const [formTouched, setFormTouched] = useState(formTouchedObj);
    const [companyFormError, setCompanyFormError] = useState(companyObject)
    const [fileError, setFileError] = useState(null);
    const [timeZone, setTimeZone] = useState([]);
    const [selectedTimeZone, setSelectedTimeZone] = useState(null); // Add state for selected timezone
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);


    useEffect(() => {
        getCompany();
    }, [])

    useEffect(() => {
        timeZonesData();
    }, [])

    useEffect(() => {
        if (Object.values(formTouched).some((touched) => touched === true)) {
        }
    }, [companies, formTouched]);


    const onUpload = () => {
        if (toast.current) {
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
        }
    };


    const getCompany = async () => {
        try {
            const companyDetails = await getRequest(`/user-accounts/get-current-user-account`, null, navigator);
            setCompanies(companyDetails)
            const companyId = companyDetails.id;
            console.log("company id :", companyId)
            // if (companyDetails.length > 0) {
            //     setCompanies(companyDetails[0]);
            // }
            return companyId; // Return the company ID for use in the patch request

        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };


    const timeZonesData = async () => {
        try {
            const timeZoneData = await getRequest('/time-zones', null, navigate);
            const formattedTimeZones = timeZoneData.map(tz => ({
                ...tz,
                name: `GMT${tz.gmt > 0 ? `${tz.gmt}` : tz.gmt} (${tz.name})`
            }));
            setTimeZone(formattedTimeZones);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleFormSubmit = async () => {
        if (!selectedTimeZone) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: 'Please select a timezone' });
            }
            return;
        }
        const payload = {
            timeZone: {
                ...selectedTimeZone,
                name: selectedTimeZone.name.split('(')[1].split(')')[0], // Extracting the name inside parentheses
            }
        };
        try {
            let res = await postRequest(`/time-zones`, payload);
            if (toast.current) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Account updated!" });
            }
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const updatedFile = e.target.files;
        const maxFileSize = 300 * 1024; // 300 KB
        const allowedTypes = ['image/jpeg', 'image/png', 'image/svg+xml'];
        if (file) {
            if (file.size > maxFileSize) {
                setFileError('File size exceeds the maximum limit of 300 KB.');
                setSelectedFile(null);
                return;
            }

            if (!allowedTypes.includes(file.type)) {
                setFileError('Invalid file type. Only JPEG and PNG are allowed.');
                setSelectedFile(null);
                return;
            }
            const img = new Image();
            img.onload = () => {
                if (img.width > 1200 || img.height > 130) {
                    setFileError('File dimensions exceed the maximum limit of 30px by 200px.');
                    setSelectedFile(null);
                } else {
                    setFileError(null);
                    setSelectedFile(file); // Store the valid file
                }
            };
            img.src = URL.createObjectURL(file);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setFileError('No file selected or file is invalid.');
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);


        // Log FormData contents for debugging
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }

        try {
            const response = await postRequest('/v1/s3/upload', formData, navigate);
            console.log(response);
            if (response.status === 200) {
                const result = response.data;
                const logoUrl = result.logoUrl || URL.createObjectURL(selectedFile);
                const filePath = result.filePath
                const logoFileName = filePath.split('/').pop();
                const companyId = await getCompany();
                const patchPayload = { id: companyId, companyLogo: logoFileName };
                const patchResponse = await patchRequest(`/user-accounts/${companyId}`, patchPayload, navigate);
                if (patchResponse.status === 200) {
                    dispatch(setCompanyLogo(logoUrl));
                    onUpload();
                } else {
                    console.error('Failed to update company logo:', patchResponse.statusText);
                    setFileError('Failed to update company logo. Please try again.');
                }
            } else {
                console.error('Upload failed:', response.statusText);
                setFileError('Upload failed. Please try again.');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            setFileError('Error uploading file. Please try again.');
        }
    };



    const handleTimeZoneChange = (e) => {
        setSelectedTimeZone(e.value);
    };
    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Grid container spacing={2}>
                {/* <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} > */}
                <Grid item xs={12} md={12} lg={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                    <Box className="card omega-forms">
                        <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Company Name *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="company-name">Enter the name of the organisation</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="name"
                                        disabled
                                        className={companyFormError.name ? 'mr-2 p-invalid' : 'mr-2'}
                                        value={companies ? companies.name : ''}
                                    />

                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Country *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="country">Enter the country where the organisation is based</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText id="country"
                                        disabled
                                        className={companyFormError.country ? 'mr-2 p-invalid' : 'mr-2'}
                                        value={companies ? companies.country : ''} />

                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Address Line 1 *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="address-line-1">Enter the address for your organisation</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText id="addressLine1"
                                        disabled
                                        value={companies ? companies.addressLine1 : ''}
                                        className={companyFormError.addressLine1 ? 'mr-2 p-invalid' : 'mr-2'} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Address Line 2</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="address-line-2">Enter the address for your organisation</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="addressLine2"
                                        disabled
                                        value={companies ? companies.addressLine2 : ''}
                                        className={companyFormError.addressLine2 ? 'mr-2 p-invalid' : 'mr-2'} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>City *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="city">Enter the city where the organisation is based</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="city"
                                        disabled
                                        value={companies ? companies.city : ''}
                                        className={companyFormError.city ? 'mr-2 p-invalid' : 'mr-2'} />

                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Zipcode *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="address-line-2">Enter the zipcode where the organisation is based</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        disabled
                                        id="zipcode"
                                        value={companies ? companies.zipcode : ''}
                                        className={companyFormError.city ? 'mr-2 p-invalid' : 'mr-2'} />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>State *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="address-line-2">Enter the state where the organisation is based</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <InputText
                                        id="state"
                                        disabled
                                        value={companies ? companies.state : ''}
                                        className={companyFormError.city ? 'mr-2 p-invalid' : 'mr-2'} />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Account Timezone *</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="full-name">Enter the timezone for the account</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Dropdown
                                        placeholder="Select Time Zone"
                                        optionLabel="name"
                                        filter
                                        value={selectedTimeZone}
                                        options={timeZone}
                                        onChange={handleTimeZoneChange}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Typography level="title-sm" className='fs-2'>Company Logo</Typography>
                                    <Typography level="body-xs" className='fs-3' htmlFor="company-logo">Upload the company logo for the account (Dimensions : 120x30 pixels; File size : max 300kb; *.jpeg, *.svg, *png)</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <div className="file-upload-inputgroup p-inputgroup flex-1">
                                        <InputText type='file' id="company-logo" className="mr-2" onChange={handleFileChange} />
                                        <label className="input-group-text" htmlFor="inputGroupFile">Upload logo</label>
                                    </div>
                                    {fileError && <div className='file-error'>{fileError}</div>}

                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                            <Button type="button" className="button-style-1" label="Upload" size="small" onClick={handleUpload}></Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}
